import { useState } from 'react';
import { DisclaimerModal } from './DisclaimerModal';
import { useSettingsStore } from '../../stores/settingsStore';

/**
 * Slim persistent disclaimer shown on trading routes once the user has
 * accepted the initial modal. Takes a single line of height so it doesn't
 * eat page real estate, but keeps the "not investment advice" signal
 * visible. Clicking "Review" re-opens the full disclaimer.
 */
export function DisclaimerStrip() {
  const [open, setOpen] = useState(false);
  const disclaimerAcceptedAt = useSettingsStore((s) => s.disclaimerAcceptedAt);
  const acceptDisclaimer = useSettingsStore((s) => s.acceptDisclaimer);

  return (
    <>
      <div
        className="flex items-center justify-center gap-3 h-6 px-3 text-[11px] text-text-muted bg-bg-tertiary/40 border-t border-border"
        role="note"
      >
        <span aria-hidden>⚠</span>
        <span>
          Educational use only · Past performance does not guarantee future results · Not investment advice.
        </span>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-accent hover:underline"
        >
          Review
        </button>
      </div>
      <DisclaimerModal
        open={open}
        acceptedAt={disclaimerAcceptedAt}
        onAccept={() => {
          acceptDisclaimer();
          setOpen(false);
        }}
      />
    </>
  );
}
